// The draft a reply box opens with: the comment's author already @mentioned,
// then a space, so the answer goes to them and the caret (autoFocus 'end')
// lands ready to type — as Jira's Reply does. The mention is an ordinary
// mention node, so it notifies them like a typed one, and can be deleted.
// Your own comment mentions you too — Reply always names the author.
//
// No mention only when there is no one to name: an author with no
// accountId (a deleted or unknown user).
//
//   replyDraft(comment) → TipTap doc

export function replyDraft(comment) {
  const author = comment?.author;
  const id = author?.accountId;
  if (!id) return { type: 'doc', content: [{ type: 'paragraph' }] };
  return {
    type: 'doc',
    content: [{
      type: 'paragraph',
      content: [
        { type: 'mention', attrs: { id: String(id), label: author.displayName || 'Unknown' } },
        { type: 'text', text: ' ' },
      ],
    }],
  };
}
